import { HttpClient } from '../http-client';

interface SuccessResponseItem {
  status: 200;
  data: {
    auth: string;
  };
}

interface FailureResponseItem {
  status: 400 | 401 | 402 | 403 | 404;
  error: {
    message: string;
  };
}

type ResponseItem = SuccessResponseItem | FailureResponseItem;

interface Request {
  socketId: string;
  channelNames: string[];
}

interface Response {
  [key: string]: ResponseItem;
}

class PusherClient extends HttpClient {
  public authorize = async (request: Request) =>
    this.post<Response, Request>('/authorise/batch/channels', request);
}

export const PusherApi = new PusherClient();
